import React from 'react';
import PropTypes from 'prop-types';
import { sidebarStatePropType } from 'components/Sidebar/propTypes';
import SingleOptionSelect from './SingleOptionSelect';

const SubStageSelect = (props) => {
  const { form, question, value } = props;
  const { options, parentStageId } = question;
  const subStageProps = {
    ...props,
    question: {
      ...question,
      options: options[form[parentStageId]?.value]
        || Object.values(options)
          .find(({ label: l, value: v }) => l === value?.label && v === value?.value) || [],
    },
  };
  return (
    <SingleOptionSelect {...subStageProps} />
  );
};

SubStageSelect.propTypes = {
  /**
   * The question.options is a object of arrays
   * The key is the value of parent stage and the value is array of options
   * Example:
   * question.options = {
   *  '2': [{label: 'Stage 2a', value: '2.1'}, {label: 'Stage 2b', value: '2.2'}],
   *  '3': [{label: 'Stage 3a', value: '3.1'}, {label: 'Stage 3b', value: '3.2'}],
   *  ....
   * }
   */
  question: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.any,
  sidebarState: sidebarStatePropType,
};

export default SubStageSelect;
